import React from "react";
import { useTranslation } from "react-i18next";
import AthleteOffering from "app/routes/Billing/AthleteOffering";
import styles from "./styles.module.scss";

interface Props {
  products: any[];
  studentId: string;
}

const FacilityOfferings = ({ products }: Props) => {
  const { t } = useTranslation();

  if (products.length === 0) {
    return <p className={styles.empty_state}>{t("No offerings available")}</p>;
  }

  // returnPath: the purchase confirmation appends ?payment=success to it.
  // AthleteHome reads that parameter and shows the success modal, and it lives
  // at /home. Route "/" redirects a logged-in athlete to /home and drops the
  // query string, so the modal never opened.
  return (
    <div className={styles.offerings_list}>
      {products.map((product) => (
        <AthleteOffering
          key={product.id}
          product={product}
          returnPath="/home"
        />
      ))}
    </div>
  );
};

export default FacilityOfferings;
